module.exports = __webpack_public_path__ + "img/banner-en.678fc46b.png";